import DashboardContainer from "../pages/unauthenticated/DashboardContainer";
import React, { FC, useEffect, useMemo, useState } from "react";
import { Navbar } from "./UnAuthenticationLayout/Navbar";
import { Banner } from "./Dashboard/Banner";
import {
  AdvaPACSPrivacyAndPolicy,
  AppLogo,
  MAX_WIDTH_MOBILE,
  MAX_WIDTH_TABLET,
  TermsOfServiceLink,
} from "@advapacs/common";

const MAX_HEIGHT_TO_FIXED_BOTTOM = 1200;

export const DashboardDefaultPage: FC = () => {
  const [isFixedBottom, setIsFixedBottom] = useState(
    document.body.clientHeight > MAX_HEIGHT_TO_FIXED_BOTTOM
  );
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < MAX_WIDTH_TABLET
  );
  const [isMobileOnly, setIsMobileOnly] = useState(
    window.innerWidth < MAX_WIDTH_MOBILE
  );

  const resize = () => {
    setIsFixedBottom(document.body.clientHeight > MAX_HEIGHT_TO_FIXED_BOTTOM);
    setIsMobileOnly(window.innerWidth < MAX_WIDTH_MOBILE);
    setIsMobile(window.innerWidth < MAX_WIDTH_TABLET);
  };

  useEffect(() => {
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const footerClassName = useMemo(() => {
    return isFixedBottom && !isMobile && !isMobileOnly ? "landing-footer" : "";
  }, [isFixedBottom, isMobile, isMobileOnly]);

  return (
    <>
      <Navbar />

      <div className="page__banner p-b-xl">
        <Banner />
        <div className="content-wrapper bg-section p-b-xl">
          <div className="content container">
            <DashboardContainer />
          </div>
        </div>
        <div className={`w-100 bg-white navbar-text ${footerClassName}`}>
          <div className="w-100 text-center p-t-xs">
            <AppLogo.LogoLong />
          </div>
          <p className=" w-100 text-center m-t-xxs text-label m-b-none">
            <span>
              © {new Date().getFullYear()} AdvaPACS by{" "}
              <a href="https://adva.health" target="_blank">
                AdvaHealth Solutions
              </a>
            </span>{" "}
            |
            <AdvaPACSPrivacyAndPolicy className="p-lr-xxs" />
            <>
              |
              <TermsOfServiceLink
                className="p-lr-xxs"
                link={`${window.location.origin}/public/terms-of-service`}
              />
            </>
          </p>
        </div>
      </div>
    </>
  );
};
